import React, { useContext, useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Spinner } from "react-bootstrap";
import { getTopupPacks } from "../../../api/context/billing";
import { buyTopupPack } from "../checkout";
import { SelectionContext } from "../../../Context/Store";
import TopupCard from "./TopupCard";

const TopupModal = ({ isOpen, toggle }) => {
  const { refreshBillingBalance } = useContext(SelectionContext);
  const [packs, setPacks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [processingCode, setProcessingCode] = useState(null);

  useEffect(() => {
    if (!isOpen) return;
    setLoading(true);
    getTopupPacks()
      .then((res) => {
        if (res?.data?.success) setPacks(res.data.data || []);
      })
      .finally(() => setLoading(false));
  }, [isOpen]);

  const handleBuy = async (pack) => {
    setProcessingCode(pack.code);
    await buyTopupPack(pack.code, {
      onSuccess: () => {
        refreshBillingBalance();
        toggle();
      },
      onDismiss: () => setProcessingCode(null),
    });
    setProcessingCode(null);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className="billing-modal billing-modal-topup"
      size="lg"
      centered
      scrollable
    >
      <ModalHeader toggle={toggle}>Buy credits</ModalHeader>
      <ModalBody>
        <p className="text-muted mb-4" style={{ fontSize: 13 }}>
          Top-up credits never expire and activate after your monthly quota
          is used.
        </p>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" size="sm" />
          </div>
        ) : (() => {
          // "Best value" = active pack with the lowest per-credit price
          let bestCode = null;
          let bestPerCredit = Infinity;
          packs.forEach((p) => {
            if (!p.listingCount) return;
            const perCredit = p.perListingPriceInPaise ?? Math.round(p.priceInPaise / p.listingCount);
            if (perCredit < bestPerCredit) {
              bestPerCredit = perCredit;
              bestCode = p.code;
            }
          });
          return (
            <div className="billing-topup-grid">
              {[...packs]
                .sort((a, b) => (a.priceInPaise || 0) - (b.priceInPaise || 0))
                .map((pack) => (
                  <TopupCard
                    key={pack.code}
                    pack={{ ...pack, isBestValue: pack.code === bestCode }}
                    isProcessing={processingCode === pack.code}
                    onBuy={handleBuy}
                  />
                ))}
            </div>
          );
        })()}
      </ModalBody>
    </Modal>
  );
};

export default TopupModal;
